import React, { Component } from 'react';
import classes from './App.module.scss';
import Layout from './containers/Layout/Layout';

import * as actionTypes from "./store/actions";
import {connect} from "react-redux";
import axios from "axios";

class App extends Component {

    componentDidMount() {

        this.props.setMode( this.props.mode );

        this.props.setInitialStateFromLocalStorage();

        let Constants = require( './data/' + this.props.mode + '-constants.js' );

        const initialParams = new URLSearchParams( window.location.search );
        const quote_hash = initialParams.get( 'quote' );

        if( quote_hash ) {

            const request_data = {
                quote_hash: quote_hash,
            };

            axios.post( Constants.ENDPOINTS.quote, request_data )
                .then( result => {

                    if( result.status === 200 ) {

                        this.props.onAppInit( result.data );

                    }
                }, error => {
                    return null;
                });
        }

    }

    render() {

        return (
            <div className={classes.App}>
                <Layout />
            </div>
        );
    }

}

const mapStateToProps = state => {
    return {
        current_screen: state.current_screen
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setInitialStateFromLocalStorage: () => dispatch( { type: actionTypes.SET_INITIAL_STATE_LOCAL_STORAGE } ),
        onAppInit: ( result_data ) => dispatch( { type: actionTypes.SET_INITIAL_STATE, result_data: result_data } ),
        setMode: ( mode ) => dispatch( { type: actionTypes.SET_MODE, mode: mode } ),
    }
};

export default connect( mapStateToProps, mapDispatchToProps )(App);
